@if (multiple) {
    <mat-form-field appearance="fill">
        <mat-label>{{ label }}</mat-label>
        <mat-chip-grid #chipList aria-label="Created By">
            @for (user of users; track user) {
                <mat-chip-row (removed)="remove(user)">
                    {{ user.name }}
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            }
            <input
                #userInput
                matInput
                [formControl]="userControl"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            />
        </mat-chip-grid>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
            @for (user of filteredUsers$ | async; track user) {
                <mat-option [value]="user">
                    {{ user.name }}
                </mat-option>
            }
        </mat-autocomplete>
    </mat-form-field>
} @else {
    <mat-form-field appearance="fill">
        <mat-label>{{ label }}</mat-label>
        <input matInput [matAutocomplete]="auto" [formControl]="userControl" />
        <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="selected($event)"
            [displayWith]="convert"
        >
            @for (user of filteredUsers$ | async; track user) {
                <mat-option [value]="user">
                    {{ user.name }}
                </mat-option>
            }
        </mat-autocomplete>
    </mat-form-field>
}
